import React, { FC } from 'react';
import styled from 'styled-components';
import { Icon } from './Icon';
import { NavigationItem } from './NavigationItem';
import { useRecoilState } from 'recoil';
import { MobileNavigationState } from '../../state/MobileNavigationState';
import { IconDefinitions } from '../..';
import { AppLogoHeader } from './AppLogoHeader';

const StyledNavigation = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  margin-top: 2rem;
`;

const StyledNav = styled.nav`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const StyledNavItems = styled.ul`
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
`;

const BurgerMenu = styled.button`
  margin-right: 2rem;

  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  cursor: pointer;
`;

export interface INavigationItem {
  text: string;
  url: string;
  icon: IconDefinitions;
}

export interface NavigationProps {
  items: INavigationItem[];
  appName: string;
  onHeaderLogoClick?: () => void;
}


export const Navigation: FC<NavigationProps> = (props) => {
  const { items, appName, onHeaderLogoClick } = props;
  const [showMobileNavigation, setShowMobileNavigation] = useRecoilState<boolean>(MobileNavigationState);

  return (
    <StyledNavigation>
      {
        items?.length > 3 &&
        <BurgerMenu
          onClick={() => {
            setShowMobileNavigation(!showMobileNavigation);
          }}
        >
          <Icon icon={showMobileNavigation ? 'close' : 'menu'} size={32} />
        </BurgerMenu>
      }
      <AppLogoHeader appName={appName} onHeaderLogoClick={onHeaderLogoClick} />
      {
        items?.length <= 3 &&
        <StyledNav>
          <StyledNavItems>
            {
              items.map((item) => (
                <NavigationItem item={item} key={item.text} />
              ))
            }
          </StyledNavItems>
        </StyledNav>
      }
    </StyledNavigation>
  );
};
